<script setup lang="ts">
definePage({
  meta: {
    requiresAuth: true,
  },
})

const { t } = useI18n()
const { enableSemesterSelector, setBreadcrumbs } = useBreadcrumbs()

onMounted(() => {
  enableSemesterSelector()
  setBreadcrumbs([
    { label: t('router.pages.manage-events'), route: '/manage/events' },
    { label: t('components.legacyImport.title') },
  ])
})
</script>

<template>
  <LegacyImportPanel />
</template>
